const defaultTheme = {
    title: 'default',

    color: {
        primary: '#FCFCFC',
        secondary: '#585858',
        unselected: '#A9A9A9',
    },

    shadow: '0 5px 38px -20px rgb(0 0 0 / 14%), 0 9px 20px -15px rgb(0 0 0 / 12%), 0 11px 15px -15px rgb(0 0 0 / 20%)',

    radius: '.8rem'
};

export default defaultTheme;